import React from 'react';
import './IntegrationStats.css';
import logoHubspot from '../../assets/Logo_crm/logo_hubspot-removebg-preview.png';
import logoSalesforce from '../../assets/Logo_crm/logo_salesforce-removebg-preview.png';
import logoPipedrive from '../../assets/Logo_crm/logo_pipedrive-removebg-preview.png';
import logoMicrosoftDynamics from '../../assets/Logo_crm/logo_microsoft_dynamics-removebg-preview.png';

const IntegrationStats = () => {
  const crmSystems = [
    { 
      id: 1, 
      name: 'HubSpot', 
      logo: logoHubspot
    },
    { 
      id: 2, 
      name: 'Salesforce', 
      logo: logoSalesforce
    },
    { 
      id: 3, 
      name: 'Pipedrive', 
      logo: logoPipedrive
    },
    { 
      id: 4, 
      name: 'Microsoft Dynamics', 
      logo: logoMicrosoftDynamics
    }
  ];

  return (
    <section className="integration-stats-section">
      <div className="integration-container">
        <div className="integration-content">
          <h2 className="integration-title">VOTRE CRM. NOTRE EXPERTISE. UNE INTÉGRATION PARFAITE.</h2>
          
          <p className="integration-description">
            Prosperian Suite se connecte nativement avec HubSpot, Salesforce, Pipedrive, Microsoft Dynamics et bien d'autres. 
            Notre équipe configure votre interface sans perturber vos opérations actuelles.
          </p>
          
          <div className="crm-systems">
            {crmSystems.map((crm) => (
              <div key={crm.id} className="crm-item" data-aos="fade-up" data-aos-delay={crm.id * 100}>
                <img src={crm.logo} alt={`Logo ${crm.name}`} className="crm-logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntegrationStats; 